<template>
  <transition name="pa-simple-fade" @enter="handleEnter" @afterEnter="handleAfterEnter">
    <div class="pa-pod-room-list-swiper" v-if="couldVisible">
      <swiper :options="podRoomListSwiperOptions" ref="podRoomListSwiper">
        <swiper-slide v-for="room in joinedPodRoomList" :key="room.id">
          <pull-to
           :top-load-method="handlePullToLoad"
           :top-config="pullToTopConfig"
           :is-bottom-bounce="false"
           :is-top-bounce="isEnbleTopBounce"
          >
            <template slot="top-block" slot-scope="props">
              <div class="top-load-wrapper">
                <!-- https://github.com/stackjie/vue-pull-to/blob/779e7a202be15943b724f4bc7ad383b0027123ed/examples/pages/SimplePullToLoadMore.vue -->
                <template v-if="props.state === 'loading'">
                  <PuffLoadingImage stroke="#957E63" />
                </template>
                <template v-else>
                  {{ props.stateText }}
                </template>
              </div>
            </template>

            <PodRoomPrevButton
             :isLoading="isLoadingPrevButton"
             @handleClick="handleListPrevButtonClick(room)"
            />

            <PodMessageListView :room="room" />

            <PodRoomFetchButton
             :room="room"
             :isLoading="isLoadingFetchButton"
             @handleClick="handleLatestFetchButtonClick(room)"
            />

            <PodRoomControlButtons
             :room="room"
             @handleClick="handleClickPodRoomControlButton(room)"
            />
          </pull-to>
        </swiper-slide>
      </swiper>
    </div>
  </transition>
</template>

<script>
import {GetPodRoomList, GetPodMessages} from '@/graphql/queries/ConnectionPod.graphql'
import {GetMessageData}                 from '@/graphql/queries/ConnectionPod.graphql'

import PodMessageListView from '@/components/Pages/Connections/ConnectionApp/components/PodRoomListView/Parts/PodMessageListView.vue'

import PodRoomListSwiperSwiperMixins      from '@/components/Pages/Connections/ConnectionApp/components/PodRoomListView/Parts/PodRoomListSwiperView/Mixins/PodRoomListSwiperSwiperMixins.js'
import PodRoomListSwiperPullToMixins      from '@/components/Pages/Connections/ConnectionApp/components/PodRoomListView/Parts/PodRoomListSwiperView/Mixins/PodRoomListSwiperPullToMixins.js'
import PodRoomListSwiperFetchButtonMixins from '@/components/Pages/Connections/ConnectionApp/components/PodRoomListView/Parts/PodRoomListSwiperView/Mixins/PodRoomListSwiperFetchButtonMixins.js'
import PodRoomListSwiperPrevButtonMixins  from '@/components/Pages/Connections/ConnectionApp/components/PodRoomListView/Parts/PodRoomListSwiperView/Mixins/PodRoomListSwiperPrevButtonMixins.js'
import PodRoomControlButtonMixins         from '@/components/Pages/Connections/ConnectionApp/components/PodRoomListView/Parts/PodRoomListSwiperView/Mixins/PodRoomControlButtonMixins.js'

export default {
  props : {
    roomTypeMeta : {
      default: null
    }
  },

  components : {
    PodMessageListView
  },

  mixins : [
    PodRoomListSwiperSwiperMixins,
    PodRoomListSwiperPullToMixins,
    PodRoomListSwiperFetchButtonMixins,
    PodRoomListSwiperPrevButtonMixins,
    PodRoomControlButtonMixins
  ],

  data(){
    return {
      isMountedPage : false,
      couldVisible  : false,

      // ページングした際のページ番号保存用
      // latestを取得するときにpageを1に戻して取得した際に前のページをどこまで読み込んだか
      // わからなくなるための保存用
      currentPage       : null,

      page              : null,
      lastPage          : null,
      total             : null
    };
  },

  apollo : {
    joinedPodRoomList : {
      query : GetPodRoomList,
      variables(){
        return {
          roomType  : this.podRoomType
        };
      },
      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    },

    podMessages     : {
      query : GetPodMessages,
      variables(){
        return {
          podRoomId : this.podRoomId,
          page      : this.page,
          orderBy   : [
            {
              column  : 'created_at',
              order   : 'DESC'
            }
          ]
        };
      },
      skip(){
        return (this.page === null);
      },
      result(result){
        const apolloClient = this.$apollo.provider.defaultClient;

        for(let message of result.data.podMessages.data){
          apolloClient.writeQuery({
            query     : GetMessageData,
            variables : {
              id  : message.id
            },
            data      : {
              podMessage : message
            }
          });
        }

        this.$store.dispatch({
          type      : 'connection/updatePodRoomData',
          podRoomId : this.podRoomId,
          loaded    : true
        });
      },
      fetchPolicy: 'no-cache',
      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    }
  },

  computed : {
    podRoomType(){
      return this.$store.state.connection.podRoomType;
    },

    podRooms(){
     return this.$store.state.connection.podRooms;
    },

    podRoomId(){
      return this.$store.state.connection.podRoomId[this.podRoomType];
    }
  },

  watch : {
    podRooms : {
      handler(){
        // ページ情報等を取得します。
        this.getPodRoomMetaData();
      },
      deep:true
    },

    // page : {
    //   handler(value){
    //     console.log(value);
    //   },
    //   immediate: true
    // },

    joinedPodRoomList : {
      handler(data){
        if(typeof data === 'undefined') return;

        this.setCouldVisible();
        this.registPodRoomList();
      },
      immediate: true
    },

    podRoomType : {
      handler(){
        this.$nextTick(() => {
          this.setSlideIndex();
        });
      },
      immediate: true
    },

    podRoomId : {
      handler(value){
        if(value === null) return;

        // podRoomIdが切り替わったら、ページ情報は初期化します。
        this.currentPage  = null;
        this.page         = null;
        this.lastPage     = null;
        this.total        = null;

        this.setSlideIndex();

        this.getPodRoomMetaData();
      },
      immediate: true
    },

    podMessages : {
      handler(data){
        if(typeof data === 'undefined') return;

        const parameters = {
          requestBehaviour  : 'prev',
          messages          : [],

          pageSet           : {
            page        : null,
            lastPage    : null,
            total       : null,
            // currentPage : null
          }
        };

        if(this.page === 1){
          parameters.requestBehaviour = 'refresh';
        }

        for(let message of data.data){
          parameters.messages.push({
            id  : message.id
          });
        }

        if(typeof data.paginatorInfo !== 'undefined'){
          parameters.pageSet.page     = data.paginatorInfo.currentPage;
          parameters.pageSet.lastPage = data.paginatorInfo.lastPage;
          parameters.pageSet.total    = data.paginatorInfo.total;
        }

        this.$store.dispatch({
          type        : 'connection/updatePodRoomData',
          podRoomId   : this.podRoomId,
          list        : parameters.messages,
          behaviour   : parameters.requestBehaviour, // 以前のページを取得する

          loaded      : true,
          page        : parameters.pageSet.page,
          lastPage    : parameters.pageSet.lastPage,
          total       : parameters.pageSet.total,
          // currentPage : parameters.pageSet.currentPage
        });
      },
      immediate: true
    },

    currentPage : {
      handler(value){
        this.page = value;
      }
    }
  },

  methods : {
    handleEnter(){
      this.$emit('handleEnter');
    },

    handleAfterEnter(){
      this.$emit('handleAfterEnter');
    },

    registPodRoomList(){
      for(let podRoom of this.joinedPodRoomList){
        this.$store.dispatch({
          type        : 'connection/updatePodRoomData',
          podRoomId   : podRoom.id,
          list        : [],
          page        : 1,
          currentPage : 1
        });
      }
    },

    setSlideIndex(){
      if(this.couldVisible === false) return;
      if(typeof this.$refs.podRoomListSwiper === 'undefined') return;
      if(typeof this.$refs.podRoomListSwiper.$swiper === 'undefined') return;
      
      for(let i = 0; i < this.joinedPodRoomList.length; i++){
        if(this.joinedPodRoomList[i].id === this.podRoomId){
          this.$refs.podRoomListSwiper.$swiper.slideTo(i);
          break;
        }
      }
    },

    setCouldVisible(){
      if(typeof this.joinedPodRoomList === 'undefined') return;
      if(this.isMountedPage === false) return;

      if(this.podRoomType === this.roomTypeMeta.slug){
        this.couldVisible = true;
      }else{
        this.couldVisible = false;
      }
    },

    getPodRoomMetaData(){
      if(typeof this.podRoomType === 'undefined') return;
      if(typeof this.podRooms === 'undefined') return;
      if(typeof this.podRoomId === 'undefined') return;

      for(let i = 0; i < this.podRooms[this.podRoomType].length; i++){
        if(this.podRooms[this.podRoomType][i].id === this.podRoomId){
          this.currentPage  = this.podRooms[this.podRoomType][i].currentPage;
          this.page         = this.podRooms[this.podRoomType][i].page;
          this.lastPage     = this.podRooms[this.podRoomType][i].lastPage;
          this.total        = this.podRooms[this.podRoomType][i].total;
        }
      }

      // console.log('[PodRoomID: '+this.podRoomId+', CurrentPage: '+this.currentPage+' Page: '+this.page+', LastPage: '+this.lastPage+', Total: '+this.total+']');
    }
  },

  created(){
    this.$parent.$parent.$parent.$parent.$on('mountedPage', () => {
      this.isMountedPage = true;
      
      this.setCouldVisible();
      this.$nextTick(() => {
        this.setSlideIndex();
      });
    });
  }
}
</script>

<style lang="scss">
.pa-pod-room-list-swiper{
  .vue-pull-to-wrapper{
    color:#957E63;
    height:100%;
  }

  .top-load-wrapper{
    text-align: center;
    padding-top:.5rem;
  }

  .swiper-container{
    min-height:100%;
  }
}
</style>